import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCoffee, fas } from '@fortawesome/free-solid-svg-icons';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { PrimengModule } from '../primeng/primeng.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { HasAnyAuthorityDirective } from './directives/has-any-authority.directive';
import { ExportTableEditComponent } from './export-table-edit/export-table-edit.component';
import { ExportTableComponent } from './export-table/export-table.component';
import { IframeComponent } from './iframe/iframe.component';
import { JhiLoginModalComponent } from './login/login.component';
import { FindLanguageFromKeyPipe } from './pipe/find-language-from-key.pipe';
import { SlugifyUppercasePipe } from './pipe/slugify-uppercase.pipe';
import { SlugifyPipe } from './pipe/slugify.pipe';
import { SelectProductTypeComponent } from './select-product-type/select-product-type.component';
import { SelectProviderComponent } from './select-provider/select-provider.component';
import { AuthServerProvider } from './service/auth-jwt.service';
import { ClipboardService } from './service/clipboard.service';
import { CSRFService } from './service/csrf.service';
import { JhiLanguageHelper } from './service/language/language.helper';
// Add an icon to the library for convenient access in other components
// library.add(faCoffee, faTwitter, fas);
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilsService } from '../../admin/services/utils.service';
import { CronComponent } from './cron/cron.component';
import { MustachePipe } from './pipe/mustache.pipe';
import { LoginModalService } from './service/login-modal.service';
import { LoginService } from './service/login.service';
import { StateStorageService } from './service/state-storage.service';
import { JhiTrackerService } from './service/tracker.service';
import { UserRouteAccessService } from './service/user-route-access-service';
import { SwaggerComponent } from './swagger/swagger.component';
import { TableI18nComponent } from './table-i18n/table-i18n.component';
import { TokenInterceptor } from './token.interceptor';
// import { CronEditorModule } from "cron-editor-with-translate";
import { MarkdownModule } from 'ngx-markdown';
import { LangInterceptor } from '../../interceptor/lang.interceptor';
import { CronJobsComponent } from './cron/cron-jobs/cron-jobs.component';
import { HasAnyAuthorityMenuDirective } from './directives/has-any-authority-menu.directive';
import { OpenDocumentationMdService } from './documentations/open-documentation-md.service';
import { SaveQueryComponent } from './save-query/save-query.component';
import { SelectSaveQueryComponent } from './select-save-query/select-save-query.component';
import { SelectTemplateHtmlComponent } from './select-template-html/select-template-html.component';
import { ViewForQueryComponent } from './view-for-query/view-for-query.component';

const cmp = [
    BreadcrumbComponent,
    IframeComponent,
    SlugifyPipe,
    SlugifyUppercasePipe,
    HasAnyAuthorityDirective,
    HasAnyAuthorityMenuDirective,
    SwaggerComponent,
    FindLanguageFromKeyPipe,
    ExportTableComponent,
    ExportTableEditComponent,
    SaveQueryComponent,
    SelectProviderComponent,
    SelectProductTypeComponent,
    TableI18nComponent,
    MustachePipe,
    CronComponent,
    ViewForQueryComponent,
    SelectTemplateHtmlComponent,
    SelectSaveQueryComponent,
    CronJobsComponent
];

@NgModule({
    exports: [
        HttpClientModule,
        CommonModule,
        // NgJhipsterModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        // component
        //
        PrimengModule,
        MonacoEditorModule,
        ...cmp,
        //
    ],
    providers: [
        LoginService,
        JhiTrackerService,
        CSRFService,
        AuthServerProvider,
        StateStorageService,
        UserRouteAccessService,
        JhiLanguageHelper,
        LoginModalService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LangInterceptor,
            multi: true,
        },
        ClipboardService,
        SlugifyUppercasePipe,
        UtilsService,
        OpenDocumentationMdService,
        {
            provide: TRANSLATE_HTTP_LOADER_CONFIG,
            useValue: {
                prefix: './assets/i18n/',
                suffix: '.json',
                enforceLoading: false,
                useHttpBackend: true,
            },
        }
    ],
    declarations: [JhiLoginModalComponent, ...cmp],
    imports: [
        CommonModule,
        FormsModule,
        PrimengModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        MonacoEditorModule.forRoot(),
        MarkdownModule.forRoot(),
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateHttpLoader,
            },
            isolate: false,
        }),
    ]
})
export class DmpSharedLibsModule {
    constructor(library: FaIconLibrary) {
        library.addIconPacks(fas as any);
        library.addIcons(faCoffee as any);
    }
}
